<template>
  <div class="equipment-box" :class="[zsTjTheme]">
    <div class="line">
      <div v-for="item in equipmentData" :key="item.type" class="item">
        <div class="card">
          <div v-if="dataSource[item.key] && dataSource[item.key].type === '专用'" class="tag">专</div>
          <div class="exchange" @click="handleItem(item)">
            <SvgIcon iconClass="zs-tj-exchange" />
          </div>
          <div :class="['img-box', item.type, { 'show-bg': dataSource[item.key] }]" @click="handleItem(item)">
            <img v-if="dataSource[item.key]" :src="dataSource[item.key].icon" class="current-icon" alt="" />
            <img v-else class="default-icon" :src="getEquipmentUrl(item.type)" alt="" />
            <template v-if="dataSource[item.key]">
              <img src="@/assets/zs_imgs/zbtj/level-r-ur.png" alt="" class="ur-icon" />
              <img
                v-if="dataSource[item.key].type === '制作'"
                class="legend-icon"
                src="@/assets/zs_imgs/zbtj/zz-level-ur4.png"
                alt=""
              />
              <div class="attr-box">
                <img class="jbnl1" :src="findAttrIcon(dataSource[item.key], 'jbnl1')" />
                <img
                  v-if="dataSource[item.key].type !== '专用'"
                  class="jbnl2"
                  :src="findAttrIcon(dataSource[item.key], 'jbnl2')"
                />
                <img
                  v-else
                  :src="
                    getCurrentIcon(
                      dataSource[item.key].zwIndex,
                      dataSource[item.key].mainAttr && dataSource[item.key].mainAttr.jbnl2
                    )
                  "
                  alt=""
                />
              </div>
              <div v-if="dataSource[item.key] && dataSource[item.key].abcsData" class="abcs-box">
                <div
                  v-for="(abc, index) in dataSource[item.key].abcsData.split('')"
                  :key="index"
                  :class="['img-bg', abc]"
                >
                  <template v-if="dataSource[item.key].propertyData">
                    <!-- <SvgIcon
                      class="icon"
                      :iconClass="
                        getAttrIcon(dataSource[item.key].propertyData[index], getPropertyOptions(dataSource[item.key]))
                      "
                    /> -->
                    <img
                      class="icon"
                      :src="
                        getAttrIcon(dataSource[item.key].propertyData[index], getPropertyOptions(dataSource[item.key]))
                      "
                      alt=""
                    />
                  </template>
                </div>
              </div>
            </template>
          </div>
          <div class="text">
            {{ dataSource[item.key] ? dataSource[item.key].name : "请选择装备" }}
          </div>
          <div class="options">
            <AbcsSelect
              @change="(val, field) => onAbcsSelectChange(val, field, item.key)"
              :value="dataSource[item.key] && dataSource[item.key].abcsData"
            />
          </div>
        </div>
        <div class="info-box">
          <div class="inner-box">
            <template v-if="dataSource[item.key]">
              <template v-if="dataSource[item.key].mainAttr">
                <template v-if="dataSource[item.key].type === '专用'">
                  <div v-if="dataSource[item.key].mainAttr.zynl" class="text-line">
                    <div class="label">{{ dataSource[item.key].mainAttr.zynl.label }}</div>
                    <div class="value">
                      {{ dataSource[item.key].mainAttr.zynl.value }}
                      <!-- {{
                        dataSource[item.key].abcsCalcData && dataSource[item.key].abcsCalcData.zynl
                          ? `+${dataSource[item.key].abcsCalcData.zynl}`
                          : ""
                      }} -->
                    </div>
                  </div>
                  <div v-if="dataSource[item.key].mainAttr.jbnl1" class="text-line">
                    <div class="label">{{ dataSource[item.key].mainAttr.jbnl1.label }}</div>
                    <div class="value">
                      {{ dataSource[item.key].mainAttr.jbnl1.value }}
                      <span class="add">
                        {{
                          dataSource[item.key].abcsCalcData && dataSource[item.key].abcsCalcData.jbnl1
                            ? `+${dataSource[item.key].abcsCalcData.jbnl1}`
                            : ""
                        }}
                      </span>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div v-if="dataSource[item.key].mainAttr.jbnl1" class="text-line">
                    <div class="label">{{ dataSource[item.key].mainAttr.jbnl1.label }}</div>
                    <div class="value">
                      {{ dataSource[item.key].mainAttr.jbnl1.value }}
                      <span class="add">
                        {{
                          dataSource[item.key].abcsCalcData && dataSource[item.key].abcsCalcData.jbnl1
                            ? `+${dataSource[item.key].abcsCalcData.jbnl1}`
                            : ""
                        }}
                      </span>
                    </div>
                  </div>
                  <div v-if="dataSource[item.key].mainAttr.jbnl2" class="text-line">
                    <div class="label">{{ dataSource[item.key].mainAttr.jbnl2.label }}</div>
                    <div class="value">
                      {{ dataSource[item.key].mainAttr.jbnl2.value }}
                      <span class="add">{{
                        dataSource[item.key].abcsCalcData && dataSource[item.key].abcsCalcData.jbnl2
                          ? `+${dataSource[item.key].abcsCalcData.jbnl2}`
                          : ""
                      }}</span>
                    </div>
                  </div>
                </template>
              </template>

              <PropertySelect
                v-if="dataSource[item.key] && dataSource[item.key].type === '专用'"
                :value="dataSource[item.key].zwIndex"
                :options="dataSource[item.key].mainAttr && dataSource[item.key].mainAttr.jbnl2"
                :abcsCalcData="dataSource[item.key].abcsCalcData && dataSource[item.key].abcsCalcData.jbnl2"
                @change="index => handleUpdateKey(index, item.key, 'zwIndex')"
              />
            </template>
          </div>
        </div>
        <div class="choose-box">
          <template v-if="dataSource[item.key] && dataSource[item.key].propertyData">
            <PropertySelect
              :value="dataSource[item.key].propertyData[0]"
              :options="getPropertyOptions(dataSource[item.key])"
              @change="index => handleUpdateProperty(index, item.key, 0)"
            />
            <PropertySelect
              :value="dataSource[item.key].propertyData[1]"
              :options="getPropertyOptions(dataSource[item.key])"
              @change="index => handleUpdateProperty(index, item.key, 1)"
            />
            <PropertySelect
              :value="dataSource[item.key].propertyData[2]"
              :options="getPropertyOptions(dataSource[item.key])"
              @change="index => handleUpdateProperty(index, item.key, 2)"
            />
          </template>
        </div>
      </div>
    </div>
    <div class="infos">
      <div v-if="isEdit || currentShowData.propertyKey1 || currentShowData.propertyKey2" class="title">
        <span class="left">副词条最佳配比</span>
        <span class="right">
          <span>[</span> <span data-map-key="propertyKey1">{{ currentShowData.propertyKey1 || "-" }}</span
          >：<span class="light" data-map-key="propertyVal1">
            {{ currentShowData.propertyVal1 || "-" }}
          </span>

          <template v-if="isEdit || (currentShowData.propertyKey2 && currentShowData.propertyVal2)">
            <span data-map-key="propertyKey2" style="margin-left: 20px">{{ currentShowData.propertyKey2 || "-" }}</span
            >：<span class="light" data-map-key="propertyVal2"> {{ currentShowData.propertyVal2 || "-" }} </span>
            <span></span> </template
          >]
        </span>
      </div>
      <div v-if="currentShowData.tips" class="tips" data-map-key="tips">
        {{ currentShowData.tips }}
      </div>
    </div>
    <EquipmentModal ref="equipmentModalRef" :list="filterList" :current="currentEditData" @close="handleUpdate" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AbcsSelect from "./AbcsSelect.vue";
import PropertySelect from "./PropertySelect.vue";
import EquipmentModal from "./equipmentModal.vue";
import { attrIcon, calculateStats, getPropertyOptions } from "@/views/wiki/zbtj/zs/abcs";

export default {
  components: {
    AbcsSelect,
    PropertySelect,
    EquipmentModal
  },
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    },
    zbListFilt: {
      type: Array,
      default: () => []
    },
    currentShowData: {
      type: Object,
      default: () => ({})
    },
    attribute: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  computed: {
    ...mapGetters(["zsTjTheme"]),
    calcAttributeObj() {
      const keys = Object.keys(this.attribute);
      const obj = {};
      keys.forEach(key => {
        const current = this.attribute[key];
        if (current.name && current.name.value) {
          const label = this.getPropertyLabel(current.name.value);
          obj[label] = current;
        }
      });
      return obj;
    },
    filterList() {
      const { zbListFilt, currentEditData } = this;
      const result = zbListFilt.filter(item => {
        return item.part === currentEditData.part;
      });
      result.sort((a, b) => {
        const aSort = a.type === "专用" ? -1 : 0;
        const bSort = b.type === "专用" ? -1 : 0;
        return aSort - bSort;
      });
      return result;
    }
  },
  data() {
    return {
      equipmentData: [
        {
          type: "wq",
          key: "武器"
        },
        {
          type: "kj",
          key: "盔甲"
        },
        {
          type: "tk",
          key: "头盔"
        },
        {
          type: "sp",
          key: "饰品"
        },
        {
          type: "st",
          key: "手套"
        }
      ],
      currentEditData: {}
    };
  },
  methods: {
    getPropertyOptions,
    findAttrIcon(object, field) {
      const { jbnl1, jbnl2, type } = object.mainAttr;
      const name1 = jbnl1.label;
      let name2 = "";
      if (type !== "专用") {
        name2 = jbnl2.label;
      }
      let icon = "";
      switch (field) {
        case "jbnl1":
          icon = attrIcon[name1];
          break;
        case "jbnl2":
          icon = attrIcon[name2];
          break;
        default:
          break;
      }
      return icon;
    },

    getEquipmentUrl(type) {
      return require(`@/assets/zs_imgs/zbtj/filt-${type}.png`);
    },
    onAbcsSelectChange(count, field, key) {
      let mainAttr = this.dataSource[key].main_attr ? JSON.parse(this.dataSource[key].main_attr) : {};
      mainAttr = Object.keys(mainAttr).reduce((prev, next) => {
        if (mainAttr[next] === "") return prev;
        prev[next] = mainAttr[next].replace(/\s/g, "");
        prev[next] = mainAttr[next];
        return prev;
      }, {});
      const object = calculateStats(mainAttr, "ur", 4, count);
      const copyData = JSON.parse(JSON.stringify(this.dataSource[key]));
      copyData.abcsData = field;
      copyData.abcsCalcData = {
        ...object
      };
      if (copyData.type === "专用") {
        copyData.abcsCalcData.jbnl2 = copyData.abcsCalcData.jbnl2.split("/").map(item => item.trim());
      }

      this.$emit("update", copyData, key);
    },
    getPropertyLabel(name) {
      if (name === "暴击率") return "致命率";
      if (name === "暴击伤害") return "致命伤害";
      return name;
    },
    getAttrIcon(index, options) {
      const current = options[index];
      if (current.icon) {
        return current.icon;
      }
      return "";
    },
    getCurrentIcon(zwIndex, jbnl2) {
      const current = jbnl2[zwIndex];
      const key = current.label;
      if (key && this.calcAttributeObj[key]) {
        return this.calcAttributeObj[key].icon && this.calcAttributeObj[key].icon.value;
      }
      return "";
    },
    handleItem(item) {
      if (this.dataSource[item.key]) {
        // Object.assign(this.currentEditData, this.dataSource[item.key]);
        this.currentEditData = {
          ...this.dataSource[item.key],
          key: item.key
        };
      } else {
        this.currentEditData = {
          ...item,
          part: item.key
        };
      }
      this.$refs.equipmentModalRef.visible = true;
    },
    // 计算abcs
    calculateCombinationValue(string) {
      const combination = string;

      const letterValues = { c: 1, b: 2, a: 3, s: 4 };
      const letters = combination.toLowerCase().split("");
      let total = 0;
      for (let i = 0; i < 3; i++) {
        const letter = letters[i];
        const positionWeight = i + 1;
        total += positionWeight * letterValues[letter];
      }

      return total + 6;
    },
    handleUpdate(data) {
      if (!data) {
        this.$emit("update", undefined, this.currentEditData.key);
        return;
      }
      const copyData = JSON.parse(JSON.stringify(data));
      const initIndex = copyData.part === "饰品" ? 9 : 7;
      // 初始化一些数据
      copyData.propertyData = copyData.propertyData || [initIndex, initIndex, initIndex];
      copyData.zwIndex = undefined;
      if (copyData.type === "专用") {
        copyData.zwIndex = 0;
      }
      copyData.abcsData = "BBS";
      copyData.abcsCalcData = {};
      // 如果abcs值没有变化，手动计算一次
      if (
        (this.dataSource[this.currentEditData.key] &&
          this.dataSource[this.currentEditData.key].abcsData === copyData.abcsData) ||
        !this.dataSource[this.currentEditData.key]
      ) {
        const count = this.calculateCombinationValue(copyData.abcsData);

        let mainAttr = copyData.main_attr ? JSON.parse(copyData.main_attr) : {};
        mainAttr = Object.keys(mainAttr).reduce((prev, next) => {
          if (mainAttr[next] === "") return prev;
          prev[next] = mainAttr[next].replace(/\s/g, "");
          prev[next] = mainAttr[next];
          return prev;
        }, {});
        const object = calculateStats(mainAttr, "ur", 4, count);
        copyData.abcsCalcData = {
          ...object
        };
        if (copyData.type === "专用") {
          copyData.abcsCalcData.jbnl2 = copyData.abcsCalcData.jbnl2.split("/").map(item => item.trim());
        }
      }

      this.$emit("update", copyData, this.currentEditData.key);
    },
    handleUpdateKey(data, key, field) {
      const obj = {
        [field]: data
      };
      this.$emit("update", obj, key);
    },
    // 修改属性
    handleUpdateProperty(data, key, index) {
      const arr = this.dataSource[key].propertyData || [];
      arr[index] = data;
      const obj = {
        propertyData: arr
      };
      this.$emit("update", obj, key);
    }
  }
};
</script>
<style lang="less" scoped>
.equipment-box {
  // flex: 1;
  width: 950px;
  margin-bottom: 20px;
  padding: 14px 10px;
  background: rgba(38, 45, 54, 0.38);
  border-radius: 8px;
  box-sizing: border-box;
  .line {
    display: flex;
    justify-content: space-between;
    margin-bottom: 22px;
    .item {
      display: flex;
      flex-direction: column;
      width: 179px;
      height: 396px;
      padding: 2px;
      border-radius: 4px;
      box-sizing: border-box;
      background: rgba(11, 11, 12, 0.4);
      .card {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 184px;
        padding-bottom: 10px;
        padding-top: 5px;
        box-sizing: border-box;
        border-radius: 4px;
        background: rgba(62, 75, 102, 0.22);
        box-sizing: border-box;
        .tag {
          font-size: 16px;
          font-weight: bold;
          text-align: center;
          padding-top: 8px;
          position: absolute;
          top: -2px;
          left: 8px;
          z-index: 1;
          width: 27px;
          height: 36px;
          color: #fff;
          box-sizing: border-box;
          background-color: #4b7499;
          clip-path: polygon(0px 0px, 27px 0px, 27px 27px, 14px 36px, 0px 27px);
        }
        .exchange {
          position: absolute;
          top: 7px;
          right: 7px;
          width: 28px;
          height: 28px;
          background-size: 100% 100%;
          cursor: pointer;
          font-size: 28px;
          color: #fff;
        }
        .img-box {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 92px;
          height: 92px;
          margin-bottom: 12px;
          background: rgba(0, 0, 0, 0.34);
          border-radius: 11px;
          // border: 1px solid rgba(255, 255, 255, 0.2);
          cursor: pointer;
          &.show-bg {
            background-image: url("~@/assets/zs_imgs/zbtj/list-item-bg.png");
            background-size: 100% 100%;
          }
          .default-icon {
            width: 44px;
            height: 44px;
          }
          .current-icon {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .ur-icon {
            position: absolute;
            right: 2px;
            top: 0;
            width: 20px;
            height: 20px;
          }
          .legend-icon {
            position: absolute;
            left: 2px;
            top: 5px;
            width: 23px;
            height: 12px;
          }
          .attr-box {
            position: absolute;
            left: 4px;
            bottom: 4px;
            display: flex;
            column-gap: 2px;
            img {
              width: 16px;
              height: 16px;
              object-fit: contain;
            }
          }
          .abcs-box {
            position: absolute;
            right: 4px;
            bottom: 5px;
            display: flex;
            align-items: center;
            gap: 0 2px;
            .img-bg {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 14px;
              height: 14px;
              .icon {
                width: 12px;
                height: 12px;
                object-fit: contain;
              }
              &.S {
                background: url("~@/assets/zs_imgs/cultivation/select-bg-S.png") no-repeat;
                background-size: 100% 100%;
              }
              &.A {
                background: url("~@/assets/zs_imgs/cultivation/select-bg-A.png") no-repeat;
                background-size: 100% 100%;
              }
              &.B {
                background: url("~@/assets/zs_imgs/cultivation/select-bg-B.png") no-repeat;
                background-size: 100% 100%;
              }
              &.C {
                background: url("~@/assets/zs_imgs/cultivation/select-bg-C.png") no-repeat;
                background-size: 100% 100%;
              }
            }
          }
        }
        .text {
          width: 100%;
          margin-bottom: 14px;
          text-align: center;
          font-weight: 500;
          font-size: 14px;
          line-height: 14px;
          color: #ffffff;
          padding: 0 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .options {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 0 3px;
          box-sizing: border-box;
        }
      }
      .info-box {
        width: 100%;
        padding: 16px 4px 0;
        box-sizing: border-box;
        .inner-box {
          height: 86px;
          padding-bottom: 7px;
          border-bottom: 1px solid rgba(185, 185, 185, 0.12);
          .text-line {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 6px;
            margin-bottom: 11px;
            line-height: 14px;
            .label {
              font-weight: 500;
              font-size: 14px;
              color: #cccccc;
            }
            .value {
              font-weight: 500;
              font-size: 14px;
              color: #cccccc;
            }
          }
        }
      }
      .choose-box {
        display: flex;
        flex-direction: column;
        gap: 4px 0;
        height: 98px;
        padding: 10px 4px 0;
      }
    }
  }
  .infos {
    .title {
      margin-bottom: 15px;
      font-weight: 600;
      font-size: 16px;
      line-height: 16px;
      color: #ffffff;
      .left {
        margin-right: 20px;
      }
      .right {
        line-height: 20px;
        .light {
          color: #fdd047;
        }
      }
    }
    .tips {
      width: 100%;
      font-weight: 500;
      font-size: 14px;
      color: #cccccc;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.equipment-box.light {
  background: rgba(226, 231, 230, 0.75);
  .line {
    .item {
      background: rgba(255, 255, 255, 0.73);
      .card {
        background: #edf2f4;
        border-radius: 4px;
        border: 2px solid #ffffff;
        .exchange {
          color: #000;
          background: rgba(237, 242, 244, 1);
        }
        .img-box {
        }
        .text {
          color: #333333;
        }
      }
      .info-box {
        .inner-box {
          .text-line {
            .label {
              color: #333333;
            }
            .value {
              color: #333333;
              .add {
                color: #2e7a99;
              }
            }
          }
        }
      }
    }
  }

  .infos {
    .title {
      font-weight: 800;
      color: #333333;
      .right {
        .light {
          color: #ff6600;
        }
      }
    }
    .tips {
      color: #333333;
    }
  }
}
</style>
